import { render, staticRenderFns } from "./UserActivityReport.vue?vue&type=template&id=048a2d05&"
import script from "./UserActivityReport.vue?vue&type=script&lang=js&"
export * from "./UserActivityReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports